export function formatDateiname(str) {
  if (!str) return '';
  return str.split(/[_\s]+/).map((w) => w.charAt(0).toUpperCase() + w.slice(1)).join('');
}

function cleanAnalyseItem(line) {
  return String(line || '')
    .replace(/<\s*parameter\s+name=["'][^"']+["']\s*>/gi, '')
    .replace(/<\s*\/\s*parameter\s*>/gi, '')
    .replace(/<\s*parameter[^>]*>/gi, '')
    .replace(/<\s*\/?\s*tool[^>]*>/gi, '')
    .replace(/^(?:[-•*]|\d+[.)])\s*/, '')
    .trim();
}

export function parseAnalyseText(text) {
  if (!text) return { score: null, staerken: [], keywords: [], optimierung: [], empfehlung: '' };

  const scoreMatch = text.match(/Übereinstimmung[:\s]+\[?\s*(\d+)\s*\/\s*10\s*\]?/i);
  const score = scoreMatch ? Math.round(parseInt(scoreMatch[1], 10) * 10) : null;

  const lines = text.split('\n').map(l => l.trim()).filter(Boolean);
  const staerken = [];
  const keywords = [];
  const optimierung = [];
  let section = null;

  for (const line of lines) {
    if (/stärken|stärken-profil|strengths/i.test(line) && !/^[-•*]/.test(line)) { section = 'staerken'; continue; }
    if (/keywords?|schlüsselwörter|suchbegriffe/i.test(line) && !/^[-•*]/.test(line)) { section = 'keywords'; continue; }
    if (/optimier|verbesser|lücken|gaps|schwächen|potenzial|was fehlt|fehlt/i.test(line) && !/^[-•*]/.test(line)) { section = 'optim'; continue; }
    if (/empfehlung|recommendation/i.test(line) && !/^[-•*]/.test(line)) { section = 'empfehlung'; continue; }
    if (/^(?:[-•*]|\d+[.)])\s*/.test(line)) {
      const item = cleanAnalyseItem(line);
      if (!item) continue;
      if (section === 'staerken') staerken.push(item);
      else if (section === 'keywords') keywords.push(item);
      else if (section === 'optim') optimierung.push(item);
    }
  }

  const empfehlungMatch = text.match(/Empfehlung[^:]*:([\s\S]*?)$/i);
  const empfehlung = empfehlungMatch ? empfehlungMatch[1].trim() : '';

  return { score, staerken, keywords, optimierung, empfehlung };
}

export function todayStr() {
  return new Date().toISOString().slice(0, 10);
}

export function eineStundeSpäter(zeit) {
  const [h, m] = zeit.split(':').map(Number);
  return `${String((h + 1) % 24).padStart(2, '0')}:${String(m).padStart(2, '0')}`;
}
